import { FC } from "react";
import { Box } from "@material-ui/core";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useStyles } from "./styles";
import Loader from "router/components/Loader";
import FleetHead from "./FleetContent/FleetHead";
import FleetStatussContainers from "./FleetContent/FleetStatusContainers";
import FleetGraphSection from "./FleetContent/FleetGraphSection";
import PaginationSwitch from "componentsNew/elements/PaginationSwitch";
import { fleetUpdateSettings, resetFleetSelectedList } from "actions/daAndFleetActions";
import { useDispatch } from "react-redux";

const FleetsPage: FC = () => {
  const classes = useStyles();
  const {
    loadingData,
    fleetData: { fleetListCount, fleetListFilters },
  } = useTypeSelectors((state) => state.daAndFleets);
  const dispatch = useDispatch();

  const handleChangePagination = (event: unknown, value: number) => {
    dispatch(fleetUpdateSettings({ pageNumber: Number(value), idListForUpdate: [] }));
    dispatch(resetFleetSelectedList());
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(fleetUpdateSettings({ rowsPerPage: Number(event.target.value), idListForUpdate: [] }));
    dispatch(resetFleetSelectedList());
  };

  return (
    <Box className={classes.root} id="Table">
      <Loader isLoading={loadingData} />
      <FleetHead />
      <Box className={classes.contentBox}>
        <FleetGraphSection />
        <FleetStatussContainers />
        <Box className={classes.tableFooter}>
          <PaginationSwitch
            page={fleetListFilters?.pageNumber}
            rowsPerPage={fleetListFilters?.rowsPerPage}
            totalPages={fleetListCount}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePagination}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default FleetsPage;
